export default {
    url: 'http://10.3.4.19/api/v1',
   //url: 'https://corpquinnox.bunzlusa.com/api/v1',
    isR3App: false,
    version : "1.1.50"
}